import { render, staticRenderFns } from "./ViewPpt.vue?vue&type=template&id=eb4b4780&"
import script from "./ViewPpt.vue?vue&type=script&lang=js&"
export * from "./ViewPpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports